// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

const appInsightsConnectionString =
  env['APP_INSIGHTS_CONNECTION_STRING'] || env['APPLICATIONINSIGHTS_CONNECTION_STRING'] || '';
const bootstrapApiKey = '8341c9e6-8adb-469b-8d66-f58cbcda720c';

export const environment = {
  production: true,
  serviceWorkerEnabled: false,
  version: env.npm_package_version,
  apiUrl: 'https://alpha-followup-api.azurewebsites.net/',
  apiKeyAuth: bootstrapApiKey,
  applicationInsights: {
    enabled: !!appInsightsConnectionString,
    connectionString: appInsightsConnectionString
  },
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US']
};
